<template>
    <LayoutDefault
        variant="white"
    >
        <OrganismPageHeader :title="$t('pages.information')" background-image="../../../img/static/FLUXUM_210831_Archi_11.jpg"/>
        <div class="py-10 px-3 md:px-12 md:text-2xl">
            <AtomSectionSeparatorText>{{ $t('info.contact.title') }}</AtomSectionSeparatorText>
            <div class="break-words mt-3 md:py-12 gap-2 flex flex-col md:flex-row">
                <div class="gap-2 flex flex-col md:w-2/3">
                    <div class="grid grid-cols-2 gap-2">
                        <div>
                            <p>
                                {{ $t("info.contact.name_fluxum") }}<br>
                                <a href="mailto:info@fluxumfoundation.org">info@fluxumfoundation.org</a><br>
                                +41 22 436 81 91
                            </p>
                        </div>

                        <div>
                            <p>
                                {{ $t("info.contact.name_lab") }}<br>
                                <a href="mailto:agenda@fluxlaboratory.com">agenda@fluxlaboratory.com</a><br>
                                +41 22 308 14 50
                            </p>
                        </div>

                        <div>
                            <p v-html="$t('info.contact.fluxum_address')">
                            </p>
                        </div>
                    </div>
                </div>

                <div class="gap-2 flex flex-col md:w-1/3">
                    <div>
                        <p>
                            Flux Laboratory Athens<br>
                            <a href="mailto:athens@fluxlaboratory.com">athens@fluxlaboratory.com</a><br>
                            +30 210 0108357
                        </p>
                    </div>

                    <div>
                        <p>
                            12 Geronta<br>
                            10558 Athens, Greece
                        </p>
                    </div>

                    <div>
                        <p>{{ $t('info.contact.rdv_athens') }}</p>
                    </div>
                </div>
            </div>

            <!--
                <AtomSectionSeparatorText>{{ $t('info.request.title') }}</AtomSectionSeparatorText>
                <div class="break-words mt-3 md:py-12 grid grid-cols-1 gap-2">
                    <div>
                        <p>{{ $t('info.request.content_1') }}</p>
                    </div>

                    <div>
                        <p>{{ $t('info.request.content_2') }}</p>
                    </div>
                </div>
            -->

            <AtomSectionSeparatorText>{{ $t('info.team.title') }}</AtomSectionSeparatorText>
            <div class="break-words mt-3 md:py-12 grid grid-cols-1 gap-4 md:gap-10 text-center">
                <div>
                    <div class="text-2xl md:text-6xl">Cynthia Odier</div>
                    <div>
                        {{ $t("info.team.odier") }}
                    </div>
                </div>

                <div>
                    <div class="text-2xl md:text-6xl">Isabelle Montégut</div>
                    <div>
                        {{ $t("info.team.montegut") }}
                    </div>
                </div>

                <div>
                    <div class="text-2xl md:text-6xl">Emilie Servettaz</div>
                    <div>
                        {{ $t("info.team.servettaz") }}
                    </div>
                </div>

                <div>
                    <div class="text-2xl md:text-6xl">Charlotte Vizern</div>
                    <div>
                        {{ $t("info.team.vizern") }}
                    </div>
                </div>

                <div>
                    <div class="text-2xl md:text-6xl">Niki Xenou</div>
                    <div>
                        {{ $t("info.team.xenou") }}
                    </div>
                </div>

                <div>
                    <div class="text-2xl md:text-6xl">Maeva Le Duc</div>
                    <div>
                        {{ $t("info.team.duc") }}
                    </div>
                </div>
            </div>

            <AtomSectionSeparatorText>{{ $t('info.team.founder.title') }}</AtomSectionSeparatorText>
            <div class="break-words mt-3 md:py-12 grid grid-cols-1 gap-4 md:gap-10 text-center">
                <div>
                    <div class="text-2xl md:text-6xl">Patrick Odier</div>
                    <div>
                        {{ $t("info.team.founder.president") }}
                    </div>
                </div>

                <div>
                    <div class="text-2xl md:text-6xl">Cynthia Odier</div>
                    <div>
                        {{ $t("info.team.founder.vice-president") }}
                    </div>
                </div>
            </div>

            <AtomSectionSeparatorText>{{ $t('info.team.board.title') }}</AtomSectionSeparatorText>
            <div class="break-words mt-3 md:py-12 grid grid-cols-1 gap-4 md:gap-10 text-center">
                <div>
                    <div class="text-2xl md:text-6xl">Daphné Bengoa</div>
                    <div>
                        {{ $t("info.team.board.bengoa") }}
                    </div>
                </div>

                <div>
                    <div class="text-2xl md:text-6xl">Aude Peyrot</div>
                    <div>
                        {{ $t("info.team.board.peyrot") }}
                    </div>
                </div>
            </div>
        </div>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import OrganismPageHeader from "../components/global/organisms/OrganismPageHeader.vue";
import AtomSectionSeparatorText from "../components/global/atoms/AtomSectionSeparatorText.vue";

export default {
    name: "PageInformation",
    components: {AtomSectionSeparatorText, OrganismPageHeader, LayoutDefault},
}
</script>

<style scoped>

</style>

